// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2AzlZ","title":"BackImages_title__OP1kn","images":"BackImages_images__3SBPM"};